import React, {Component} from "react"
import PropTypes from "prop-types"
import isEqual from "lodash/isEqual"
import styled, {css} from "styled-components"
import {FaKey, FaGlobe} from "react-icons/fa"

import {ImpulseSpinner} from "react-spinners-kit" // https://dmitrymorozoff.github.io/react-spinners-kit/

import * as selectors from "../../data/selectors"

class CIcon extends Component {
  static propTypes = {
    debug: PropTypes.bool,
    id: PropTypes.string.isRequired,
    scale: PropTypes.number,
    color: PropTypes.string,
    colorSecondary: PropTypes.string,
    onClick: PropTypes.func,
    rotationDegrees: PropTypes.number,
    inline: PropTypes.bool,
    ty: PropTypes.number, // -> transform: translate3d()
  }
  static defaultProps = {
    debug: false && __DEV__,
    scale: 1,
    color: "black",
    rotationDegrees: 0,
    ty: 0,
  }

  shouldComponentUpdate = (nextProps, nextState) => !(isEqual(nextProps, this.props) && isEqual(nextState, this.state))

  renderIcon = () => {
    let {id, color, colorSecondary, scale, rotationDegrees} = this.props

    let pathProps = {
      fill: color,
      style: {
        transition: "fill 0.5s ease-in-out",
      },
    }
    const svgProps = {pathProps, scale}

    switch (id) {
      case "HomeShowVideoIntro": {
        return <SvgVideoPlayIcon {...svgProps} />
      }
      case "HeaderMenuCaretDown": {
        return (
          <svg style={{width: "100%", transform: `rotate(${rotationDegrees}deg)`, transition: "all 0.8s"}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 10.1 5.6">
            <g>
              <g>
                <path
                  {...pathProps}
                  d="M5.1,5.4c-0.1,0-0.2-0.1-0.3-0.1L0.4,0.9c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l4,4l4-4
                  c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7L5.4,5.3C5.3,5.4,5.2,5.4,5.1,5.4z"
                />
              </g>
            </g>
          </svg>
        )
      }
      case "HeaderMenuSearch": {
        scale *= 0.65
        return (
          <svg style={{width: "100%"}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 20.6 21">
            <path
              {...pathProps}
              d="M20.4,20.2l-8.3-8.3c1.2-1.2,1.9-2.9,1.9-4.7c0-3.8-3.1-6.9-6.9-6.9c-3.8,0-6.9,3.1-6.9,6.9S3.3,14,7.1,14
              c1.6,0,3.1-0.6,4.3-1.5l8.4,8.4L20.4,20.2z M1.1,7.1c0-3.3,2.7-5.9,5.9-5.9S13,3.8,13,7.1S10.3,13,7.1,13S1.1,10.3,1.1,7.1z"
            />
          </svg>
        )
      }
      case "FooterTwitter": {
        return (
          <svg style={{width: scale * 17}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 17 14">
            <path
              {...pathProps}
              d="M17.037,1.639c-0.626,0.278-1.301,0.466-2.007,0.55c0.722-0.433,1.276-1.117,1.537-1.933
              c-0.676,0.4-1.423,0.691-2.22,0.847C13.71,0.424,12.801,0,11.795,0C9.866,0,8.301,1.565,8.301,3.495c0,0.274,0.03,0.541,0.09,0.796
              C5.486,4.145,2.911,2.755,1.186,0.639C0.885,1.157,0.713,1.757,0.713,2.398c0,1.211,0.617,2.282,1.555,2.909
              C1.695,5.289,1.156,5.13,0.684,4.87v0.043c0,1.694,1.205,3.107,2.805,3.427C3.195,8.422,2.887,8.463,2.567,8.463
              c-0.225,0-0.445-0.021-0.657-0.062c0.444,1.388,1.735,2.399,3.265,2.426c-1.196,0.938-2.704,1.497-4.341,1.497
              c-0.282,0-0.561-0.016-0.834-0.048c1.547,0.991,3.384,1.57,5.358,1.57c6.43,0,9.945-5.325,9.945-9.945
              c0-0.152-0.003-0.303-0.009-0.452C15.977,2.956,16.57,2.34,17.037,1.639"
            />
          </svg>
        )
      }
      case "FooterFacebook": {
        return (
          <svg style={{width: scale * 8}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 8 17">
            <path
              {...pathProps}
              d="M0,5.624h1.758V3.916C1.758,3.162,1.777,2,2.325,1.28C2.901,0.518,3.693,0,5.054,0
              c2.218,0,3.152,0.316,3.152,0.316L7.767,2.921c0,0-0.733-0.212-1.417-0.212c-0.684,0-1.296,0.245-1.296,0.929v1.986h2.804
              L7.663,8.169H5.054v8.839H1.758V8.169H0V5.624z"
            />
          </svg>
        )
      }
      case "FooterInstagram": {
        return (
          <svg style={{width: scale * 17, transform: "translate3d(1px,1px,0px)"}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 17 17">
            <path
              {...pathProps}
              d="M13.721,0H3.287C1.475,0,0,1.474,0,3.287v3.472v6.963c0,1.812,1.475,3.287,3.287,3.287h10.434
              c1.812,0,3.287-1.474,3.287-3.287V6.758V3.287C17.008,1.474,15.533,0,13.721,0z M14.664,1.96l0.376-0.002v0.375v2.508l-2.874,0.009
              l-0.01-2.883L14.664,1.96z M6.077,6.758C6.621,6.004,7.505,5.51,8.504,5.51s1.883,0.494,2.427,1.248
              c0.355,0.492,0.567,1.094,0.567,1.746c0,1.65-1.344,2.993-2.994,2.993s-2.993-1.343-2.993-2.993C5.511,7.852,5.723,7.25,6.077,6.758
              z M15.351,13.721c0,0.899-0.73,1.629-1.63,1.629H3.287c-0.899,0-1.63-0.73-1.63-1.629V6.758h2.539
              c-0.22,0.54-0.343,1.128-0.343,1.746c0,2.564,2.086,4.651,4.65,4.651c2.564,0,4.65-2.087,4.65-4.651
              c0-0.617-0.124-1.206-0.343-1.746h2.539V13.721z"
            />
          </svg>
        )
      }
      case "FooterEmail": {
        scale *= 0.6
        return (
          <svg style={{width: scale * 30}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 30 24">
            <g>
              <path {...pathProps} d="M28.2,2.1H1.8c-0.1,0-0.2,0.2-0.1,0.3l13.2,9.3c0,0,0.1,0,0.2,0l13.3-9.3C28.4,2.3,28.4,2.1,28.2,2.1z" />
              <path
                {...pathProps}
                d="M14.9,13.9c-0.1,0-0.2,0-0.3-0.1l-14-9.9C0.5,3.8,0.4,3.9,0.4,4v17.8c0,0.1,0.1,0.1,0.1,0.1h28.9
                c0.1,0,0.1-0.1,0.1-0.1V4c0-0.1-0.1-0.2-0.2-0.1l-14.2,9.9C15.1,13.8,15,13.9,14.9,13.9z"
              />
            </g>
          </svg>
        )
      }
      case "FooterLinkedin": {
        scale *= 0.9
        return (
          <svg style={{width: scale * 20, transform: "translate3d(0px,0px,0px)"}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 20 20">
            <path d="M20 19h-4.42v-6.328c0-1.656-.691-2.786-2.213-2.786-1.163 0-1.808.762-2.11 1.498-.112.264-.096.631-.096.999V19H6.783s.056-11.209 0-12.228h4.378v1.92c.259-.84 1.658-2.038 3.893-2.038 2.77 0 4.946 1.76 4.946 5.546V19zM2.354 5.243h-.029C.915 5.243 0 4.308 0 3.123 0 1.916.943 1 2.381 1c1.438 0 2.323.914 2.352 2.12 0 1.184-.914 2.123-2.38 2.123zM.504 19h3.898V6.772H.504V19z" {...pathProps} fillRule="evenodd" />
          </svg>
        )
      }
      case "FooterYoutube": {
        scale *= 1.0
        return (
          <svg style={{width: scale * 22}} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 345.8 237.8">
            <path {...pathProps} d="M337.5,37.3c-4-14.7-15.3-26.2-30.4-30.1C280.3,0,172.2,0,172.2,0c0,0-107.8,0-134.5,7.3-14.8,3.9-26.4,15.3-30.7,30.1C0,63.5,0,118.7,0,118.7c0,0,0,55.5,7.1,81.9,4.2,14.4,15.8,26,30.7,30.1,26.7,7.1,134.5,7.1,134.5,7.1h0s108,0,134.8-7.1c15.1-4,26.4-15.7,30.4-30.1,7.4-26.4,7.4-81.9,7.4-81.9,0,0,0-55.2-7.4-81.3ZM136.8,169.5v-101.1l89.2,50.5-89.2,50.5Z" />
          </svg>
        )
      }
      case "TutorialPlay": {
        pathProps.fill = "white"
        return (
          <svg style={{width: scale * 37}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 37 42">
            <path {...pathProps} d="M36.3,20.9L0.7,0.4c-0.1,0-0.1,0-0.1,0.1v41c0,0.1,0.1,0.1,0.1,0.1l35.5-20.5C36.3,21,36.3,21,36.3,20.9z" />
          </svg>
        )
      }
      case "PersonLinkedin": {
        return (
          <svg style={{width: scale * 30}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 30 24">
            <path
              {...pathProps}
              d="M10.7,20.3H7.1V9h3.5V20.3z M8.8,7.6L8.8,7.6c-1.3,0-2.1-0.9-2.1-2c0-1.1,0.9-2,2.1-2c1.3,0,2.1,0.8,2.1,2
              C11,6.7,10.1,7.6,8.8,7.6z M24.7,20.3h-4v-5.8c0-1.5-0.6-2.6-2-2.6c-1,0-1.6,0.7-1.9,1.4c-0.1,0.2-0.1,0.6-0.1,0.9v6.1h-4
              c0,0,0.1-10.3,0-11.3h4v1.8c0.2-0.8,1.5-1.9,3.5-1.9c2.5,0,4.5,1.6,4.5,5.1V20.3z"
            />
          </svg>
        )
      }
      case "PersonWeb": {
        return (
          <div style={{paddingTop: 5}}>
            <FaGlobe size={25 * scale} color={color} />
          </div>
        )
      }
      case "ButtonBusy": {
        // return <RotateSpinner size={20} color={color} loading={true} />
        return <ImpulseSpinner size={17 * scale} frontColor={color} loading={true} />
      }
      case "AdminLocked": {
        // return <RotateSpinner size={20} color={color} loading={true} />
        return <FaKey size={11 * scale} color={color} />
      }
      case "Feature": {
        scale *= 0.8
        return (
          <svg style={{width: scale * 30}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 30 24">
            <g>
              <g>
                <path
                  {...pathProps}
                  d="M15,23.7c-3.1,0-6.1-1.2-8.3-3.4C4.5,18,3.3,15.1,3.3,12c0-3.1,1.2-6,3.4-8.3c4.5-4.6,12-4.6,16.5,0l0,0
                  c4.6,4.6,4.6,12,0,16.5C21.1,22.5,18.1,23.7,15,23.7z M15,2.3c-2.5,0-5,0.9-6.8,2.8C6.3,7,5.3,9.4,5.3,12s1,5,2.8,6.8
                  s4.3,2.8,6.8,2.8s5-1,6.8-2.8c3.8-3.8,3.8-9.9,0-13.7C20,3.3,17.5,2.3,15,2.3z"
                />
              </g>
              <g>
                <path
                  {...pathProps}
                  d="M12.7,17.3C12.7,17.3,12.6,17.2,12.7,17.3c-0.4,0-0.7-0.2-0.8-0.5l-2.2-3.6c-0.3-0.5-0.2-1.1,0.3-1.4
                  c0.5-0.3,1.1-0.2,1.4,0.3l1.5,2.5l6.7-7.5c0.4-0.4,1-0.4,1.4-0.1c0.4,0.4,0.4,1,0.1,1.4l-7.6,8.5C13.3,17.1,13,17.3,12.7,17.3z"
                />
              </g>
            </g>
          </svg>
        )
      }
      case "FeatureUnchecked": {
        scale *= 0.8
        return (
          <svg style={{width: scale * 30}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 30 24">
            <g>
              <g>
                <path
                  {...pathProps}
                  d="M15,23.7c-3.1,0-6.1-1.2-8.3-3.4C4.5,18,3.3,15.1,3.3,12c0-3.1,1.2-6,3.4-8.3c4.5-4.6,12-4.6,16.5,0l0,0
                  c4.6,4.6,4.6,12,0,16.5C21.1,22.5,18.1,23.7,15,23.7z M15,2.3c-2.5,0-5,0.9-6.8,2.8C6.3,7,5.3,9.4,5.3,12s1,5,2.8,6.8
                  s4.3,2.8,6.8,2.8s5-1,6.8-2.8c3.8-3.8,3.8-9.9,0-13.7C20,3.3,17.5,2.3,15,2.3z"
                />
              </g>
              {false && (
                <g>
                  <path
                    {...pathProps}
                    d="M12.7,17.3C12.7,17.3,12.6,17.2,12.7,17.3c-0.4,0-0.7-0.2-0.8-0.5l-2.2-3.6c-0.3-0.5-0.2-1.1,0.3-1.4
                  c0.5-0.3,1.1-0.2,1.4,0.3l1.5,2.5l6.7-7.5c0.4-0.4,1-0.4,1.4-0.1c0.4,0.4,0.4,1,0.1,1.4l-7.6,8.5C13.3,17.1,13,17.3,12.7,17.3z"
                  />
                </g>
              )}
            </g>
          </svg>
        )
      }
      case "MobileMenuClose": {
        pathProps.fill = color
        return (
          <svg style={{width: scale * 16}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16">
            <g id="Capa_1">
              <polygon {...pathProps} points="15.5,1.4 14.6,0.5 8,7 1.4,0.5 0.5,1.4 7,8 0.5,14.6 1.4,15.5 8,9 14.6,15.5 15.5,14.6 9,8  " />
            </g>
          </svg>
        )
      }
      case "MobileMenuHamburger": {
        pathProps.fill = color
        scale *= 0.8
        return (
          <svg style={{width: scale * 33}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 33 25">
            <g id="Capa_1">
              <g>
                <rect {...pathProps} x="1.5" y="1" width="30" height="3" />
                <rect {...pathProps} x="1.5" y="11" width="30" height="3" />
                <rect {...pathProps} x="11.6" y="21" width="19.9" height="3" />
              </g>
            </g>
          </svg>
        )
      }
      case "MobileMenuSearch": {
        pathProps.fill = "black"
        scale *= 0.8
        return (
          <svg style={{width: scale * 25}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 25 25">
            <g id="Capa_1">
              <path {...pathProps} d="M23.8,21.9L15.9,14c1.1-1.4,1.7-3.1,1.7-4.9c0-4.5-3.7-8.2-8.2-8.2c-4.5,0-8.2,3.7-8.2,8.2c0,4.5,3.7,8.2,8.2,8.2 c1.6,0,3-0.4,4.3-1.2l8,8L23.8,21.9z M4.2,9.1c0-2.8,2.3-5.2,5.2-5.2s5.2,2.3,5.2,5.2c0,2.8-2.3,5.2-5.2,5.2S4.2,11.9,4.2,9.1z" />
            </g>
          </svg>
        )
      }
      case "FaqPlus": {
        pathProps.fill = "black"
        // scale *= 0.8
        return (
          <svg style={{width: scale * 16}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16">
            <g>
              <path {...pathProps} d="M13.1,2.9c-2.8-2.8-7.3-2.8-10.1,0c-2.8,2.8-2.8,7.3,0,10.1c1.4,1.4,3.2,2.1,5.1,2.1c1.8,0,3.7-0.7,5.1-2.1 C15.9,10.3,15.9,5.7,13.1,2.9z M12.4,12.4c-2.4,2.4-6.3,2.4-8.7,0C1.2,10,1.2,6,3.6,3.6c2.4-2.4,6.3-2.4,8.7,0 C14.8,6,14.8,10,12.4,12.4z" />
              <polygon {...pathProps} points="8.5,7.5 8.5,3.6 7.5,3.6 7.5,7.5 3.6,7.5 3.6,8.5 7.5,8.5 7.5,12.4 8.5,12.4 8.5,8.5 12.4,8.5 12.4,7.5  " />
            </g>
          </svg>
        )
      }
      case "FaqMinus": {
        pathProps.fill = "black"
        // scale *= 0.8
        return (
          <svg style={{width: scale * 16}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16">
            <g>
              <path {...pathProps} d="M13.1,2.9c-2.8-2.8-7.3-2.8-10.1,0c-2.8,2.8-2.8,7.3,0,10.1c1.4,1.4,3.2,2.1,5.1,2.1c1.8,0,3.7-0.7,5.1-2.1 C15.9,10.3,15.9,5.7,13.1,2.9z M12.4,12.4c-2.4,2.4-6.3,2.4-8.7,0C1.2,10,1.2,6,3.6,3.6c2.4-2.4,6.3-2.4,8.7,0 C14.8,6,14.8,10,12.4,12.4z" />
              <rect x="3.6" y="7.5" {...pathProps} width="8.8" height="1" />
            </g>
          </svg>
        )
      }
      case "MapLocation": {
        pathProps.fill = "white"
        return (
          <svg style={{width: scale * 45}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 44.9 59.7">
            <g id="Capa_1">
              <g>
                <polygon {...pathProps} points="20.1,34.7 24.8,34.7 22.4,16.3    " />
                <path {...pathProps} d="M22.5,2C10.9,2,1.4,11.5,1.4,23.1c0,11.7,21.1,34.7,21.1,34.7s21.1-23,21.1-34.7C43.7,11.5,34.2,2,22.5,2z M15.4,38.6l4.1-27.9h5.9l4.2,27.9H15.4z" />
              </g>
            </g>
          </svg>
        )
      }
      case "NoWalls": {
        return (
          <svg width={"100%"} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 175 147">
            <path
              //
              d="M72.506.26L44.997 27.589H.957v103.834h30.756v15.38h143.099V42.97h-30.757V27.589h-44.042L72.506.26zm0 3.565l23.919 23.764H48.586l23.92-23.764zM3.494 128.903h138.025V30.111H3.494v98.792zm160.884-83.412h7.898v7.737l-7.898-7.737zm-15.088 0h11.475l11.51 11.277v11.373L149.29 45.49zm-5.235 9.603v-9.603h1.631l26.59 26.2v11.364l-28.221-27.96zm0 14.925V58.655l28.22 27.96v11.363l-28.22-27.96zm0 14.923V73.578l28.22 27.961v11.365l-28.22-27.962zm0 14.924V88.503l28.22 27.96v11.363l-28.22-27.96zm0 14.925v-11.365l28.22 27.96v11.365l-28.22-27.96zm0 14.88v-11.32l26.174 25.933h-11.378l-14.796-14.613zm-13.839 1.752h12.014l13.023 12.861h-12.014l-13.023-12.861zm-15.611 0h12.012l13.023 12.861h-12.013l-13.022-12.861zm-15.612 0h12.012l13.021 12.861h-12.012l-13.021-12.861zm-15.612 0h12.012l13.02 12.861H96.401l-13.02-12.861zm-15.614 0H79.78l13.022 12.861H80.79l-13.022-12.861zm-15.613 0h12.014l13.021 12.861H65.177l-13.023-12.861zm-15.612 0h12.013l13.022 12.861H49.563l-13.02-12.861zm-2.291 1.292l11.713 11.569H34.25v-11.569zm97.289-93.12v79.541H13.47v-79.54H131.54zm-2.538 2.522H16.01v74.498h112.993V42.117zM71.736 98.416v7.219H69.04v-7.219h2.696zm-2.05-44.414c3.362-.9 6.72-.831 9.837.262a13.295 13.295 0 0 1 4.498 2.644c1.297 1.165 2.346 2.632 3.117 4.362.77 1.73 1.161 3.75 1.161 6 0 2.216-.37 4.086-1.1 5.564-.724 1.464-1.678 2.7-2.836 3.678a17.861 17.861 0 0 1-3.777 2.427 75.935 75.935 0 0 0-3.893 2.005c-.731.408-1.414.857-2.025 1.33-.57.44-1.077 1.066-1.509 1.859-.444.816-.795 1.877-1.041 3.152-.254 1.301-.382 2.991-.382 5.023v.63H69.04v-.63c0-2.304.16-4.244.477-5.765.32-1.544.775-2.855 1.35-3.899.584-1.063 1.301-1.927 2.13-2.571a14.971 14.971 0 0 1 2.533-1.591c1.146-.57 2.33-1.14 3.548-1.71a14.925 14.925 0 0 0 3.219-2.04c.951-.793 1.752-1.803 2.377-3 .617-1.18.93-2.753.93-4.674 0-1.932-.318-3.611-.945-4.99-.624-1.373-1.47-2.515-2.51-3.396a10.382 10.382 0 0 0-3.6-1.972c-2.679-.843-5.527-.833-8.206-.1a14.19 14.19 0 0 0-3.69 1.595 15.064 15.064 0 0 0-3.083 2.519 13.185 13.185 0 0 0-2.248 3.283l-.268.551-2.43-1.074.263-.577a14.907 14.907 0 0 1 2.72-4.073 17.239 17.239 0 0 1 3.707-2.98 17.232 17.232 0 0 1 4.373-1.842z"
              fill={color}
              fillRule="evenodd"
              // opacity={0.498}
            />
          </svg>
        )
      }
      case "CaretBack": {
        return (
          <svg width={"100%"} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 12 19">
            <path d="M11 18L2 9.5 11 1" stroke={color} strokeWidth={2} fill="none" fillRule="evenodd" />
          </svg>
        )
      }
      case "RoundedCaretRight": {
        // Umbrella Pages / CUmbrellaButton
        const colorArrow = !!colorSecondary ? colorSecondary : "#FFF"
        return (
          <svg style={{width: scale * 26}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 26 26">
            <g fill="none" fillRule="evenodd">
              <circle fill={color} cx={13} cy={12.649} r={12.649} />
              <path fill={colorArrow} d="M10.892 8.282l4.484 4.366-4.484 4.366.568.554 5.054-4.92L11.46 7.73z" />
            </g>
          </svg>
        )
      }
      case "FeatureChartQuestionMark": {
        return (
          <svg style={{width: scale * 13}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 13 13">
            <g fill="none" fillRule="evenodd">
              <circle fill="#778080" opacity={0.5} cx={6.5} cy={6.5} r={6.5} />
              <path d="M6.698 9.232v1.474H5.335V9.232h1.363zm.223-6.938c.365 0 .73.044 1.095.135.365.09.688.226.97.41.283.182.51.418.69.707.177.289.265.632.265 1.029 0 .273-.042.512-.126.714a1.75 1.75 0 0 1-.354.544c-.153.16-.336.298-.549.416a6.702 6.702 0 0 1-.688.327c-.187.078-.376.16-.562.245a2.49 2.49 0 0 0-.505.304c-.148.117-.27.257-.364.416-.092.16-.14.353-.14.58H5.305c0-.406.086-.765.26-1.077.172-.312.496-.58.97-.807.167-.078.366-.166.593-.264.226-.098.44-.212.643-.345.203-.132.377-.288.52-.468a.98.98 0 0 0 .214-.632.97.97 0 0 0-.133-.503 1.157 1.157 0 0 0-.363-.374 1.723 1.723 0 0 0-.519-.228 2.35 2.35 0 0 0-.6-.077 2.37 2.37 0 0 0-1.66.656 2.64 2.64 0 0 0-.325.374l-1.081-.573c.268-.483.684-.856 1.253-1.117a4.345 4.345 0 0 1 1.844-.392z" fill="#FFF" />
            </g>
          </svg>
        )
      }
      case "FeatureChartAvailable": {
        return (
          <svg style={{width: scale * 20}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 20 20">
            <g fill="none" fillRule="evenodd">
              <circle fill="#32BC83" cx={10} cy={10} r={10} />
              <path stroke="#FFF" fill="#FFF" fillRule="nonzero" d="M7.524 13.476l-1.977-3.255-.712.433 2.57 4.23 8.1-9.32-.628-.546z" />
            </g>
          </svg>
        )
      }
      case "FeatureChartPartiallyAvailable": {
        return (
          <svg style={{width: scale * 20}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 20 20">
            <g fill="none" fillRule="evenodd" opacity={0.3}>
              <circle fill="#1E1E1E" cx={10} cy={10} r={10} />
              <path d="M4.998 10.237l9.847.08" fill="#FFF" stroke="#FFF" strokeWidth={3} />
            </g>
          </svg>
        )
        // return (
        //   <svg style={{width: scale * 20}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 20 20">
        //     <g fill="none" fillRule="evenodd" opacity={0.3}>
        //       <circle fill="#778080" cx={10} cy={10} r={10} />
        //       <path d="M4.998 10.237l9.847.08" fill="#FFF" stroke="#FFF" strokeWidth={3} />
        //     </g>
        //   </svg>
        // )
      }
      case "FeatureChartUnavailable": {
        return (
          <svg style={{width: scale * 20}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 20 20">
            <g fill="none" fillRule="evenodd" opacity={0.1}>
              <circle fill="#1E1E1E" cx={10} cy={10} r={10} />
              <path d="M14.705 5.26l.59.59-4.428 4.428 4.428 4.427-.59.59-4.427-4.428-4.428 4.428-.59-.59 4.429-4.427L5.26 5.85l.59-.59 4.427 4.429 4.427-4.428z" fill="#FFF" fillRule="nonzero" stroke="#FFF" />
            </g>
          </svg>
        )
        // return (
        //   <svg style={{width: scale * 20}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 20 20">
        //     <g fill="none" fillRule="evenodd" opacity={0.501}>
        //       <circle fill="#1E1E1E" cx={10} cy={10} r={10} />
        //       <path d="M14.705 5.26l.59.59-4.428 4.428 4.428 4.427-.59.59-4.427-4.428-4.428 4.428-.59-.59 4.429-4.427L5.26 5.85l.59-.59 4.427 4.429 4.427-4.428z" fill="#FFF" fillRule="nonzero" stroke="#FFF" />
        //     </g>
        //   </svg>
        // )
      }
      case "FeatureChartSwipe": {
        return (
          <svg style={{width: scale * 20}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 20 20">
            <path
              d="M10.926 2.718l.03.148.022.147.22 1.906.177 1.656c.291-.346.71-.547 1.233-.567h.179l.11.004c.625.023 1.165.329 1.476.777.261-.144.57-.232.898-.245h.165l.184.012c.863.09 1.49.658 1.642 1.507.216-.113.461-.182.72-.195h.386c.882.032 1.45.72 1.475 1.508v.132l.03 2.676-.019.822.004.308a8.085 8.085 0 0 1-.185 1.684c-.068.299-.154.576-.26.829-1.393 3.271-3.688 4.299-6.868 4.161-2.915-.127-6.209-1.917-7.256-4.814-1.1-3.04-.09-5.52 2.307-6.124l.042-3.72.011-.578.024-.864.023-.53c.07-1.083.504-1.74 1.392-1.907.898-.169 1.617.352 1.838 1.267zm-1.614-.282c-.283.053-.442.265-.5.831l-.017.247-.022.583-.025 1.056-.043 3.425-.016 4.039H7.583L7.59 10.1c-1.613.562-2.1 2.412-1.251 4.76.887 2.452 3.762 4.015 6.257 4.123 2.747.12 4.585-.703 5.783-3.52.083-.195.153-.42.208-.667.111-.492.157-1.007.163-1.452l-.002-.285.018-.88-.032-2.792c-.018-.27-.156-.46-.326-.504l-.065-.01h-.23c-.287-.011-.535.171-.59.418l-.012.084-.092 2.352-1.106-.036.005-.12h-.01l-.12-3.16c-.019-.517-.27-.799-.667-.852l-.102-.009-.138.001c-.321.026-.572.213-.627.443l-.011.078-.095 2.672-1.106-.032.004-.152h-.015l.114-2.859c.015-.333-.245-.618-.597-.675l-.098-.01-.109-.003c-.362-.013-.565.137-.67.544l-.026.118-.453 2.709-.529-.086-.562-.077.01-.063.008-.146v-.201a30.65 30.65 0 0 0-.134-1.996l-.16-1.614-.174-1.573-.192-1.63c-.08-.458-.286-.611-.548-.562zM3.086.308l.718.64-1.794 1.66 4.396-.106.03 1.006-4.379.105 1.9 1.549-.672.68L0 3.165 3.086.308zM16.261 0L19.1 2.706l-3.077 2.86-.72-.639L17.13 3.23l-4.43.084-.023-1.006 4.524-.086-1.667-1.59.728-.631z"
              fill="#1E1E1E"
              fillRule="nonzero"
            />
          </svg>
        )
      }
      case "TestimonialStar": {
        return (
          <svg style={{width: scale * 15}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 15 15">
            <path
              //
              d="M11.668 14.996a.723.723 0 0 1-.346-.087l-3.833-2.107-3.833 2.107a.722.722 0 0 1-.794-.061.808.808 0 0 1-.296-.775l.751-4.443L.221 6.474a.817.817 0 0 1-.188-.79.762.762 0 0 1 .609-.536l4.284-.655L6.812.445A.75.75 0 0 1 7.49 0a.75.75 0 0 1 .676.445l1.91 4.04 4.283.655c.284.043.52.25.61.537a.817.817 0 0 1-.189.789l-3.096 3.156.751 4.443a.808.808 0 0 1-.3.79c-.136.1-.3.15-.466.141z"
              fill="#eeb83e"
              fillRule="evenodd"
            />
          </svg>
        )
      }
      case "UmbrellaFeature": {
        return (
          <svg style={{width: scale * 32}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32 32">
            <g transform="translate(1 1)" fill="none" fillRule="evenodd">
              <path stroke="#32A1BC" fill="#32A1BC" fillRule="nonzero" d="M11.624 19.74l-2.696-4.438-.971.59 3.503 5.768L22.508 8.952l-.858-.746z" />
              <circle stroke="#32A1BC" strokeWidth={2} cx={15} cy={15} r={15} />
            </g>
          </svg>
        )
      }
      case "OvrFilters": {
        return (
          <svg style={{width: scale * 22, transform: "translate3d(0px,2px,0px)"}} viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="icons/filter" fill="#000000" fillRule="nonzero">
                <path
                  d="M9.41554196,14.6670975 C10.9042046,14.6670975 12.1476366,15.7165554 12.446402,17.1160356 L22,17.1158705 L22,18.4166826 L12.4463984,18.4165772 C12.1476179,19.8162453 10.9041328,20.8662158 9.41554196,20.8662158 C7.92687932,20.8662158 6.68287233,19.8161828 6.383957,18.4165528 L3,18.4166826 L3,17.1158705 L6.38395334,17.11606 C6.6828536,15.7166179 7.92680748,14.6670975 9.41554196,14.6670975 Z M9.41554196,15.9679096 C8.42205483,15.9679096 7.61641476,16.7732042 7.61641476,17.7662765 C7.61641476,18.7595562 8.42226228,19.5654037 9.41554196,19.5654037 C10.4086142,19.5654037 11.2139089,18.7597636 11.2139089,17.7662765 C11.2139089,16.7729968 10.4088216,15.9679096 9.41554196,15.9679096 Z M17.3918821,8.33335868 C18.8810048,8.33335868 20.1246716,9.38321666 20.4234905,10.7829533 L21.9997719,10.7828919 L21.9997719,12.083704 L20.4234942,12.0835829 C20.1246903,13.4831316 18.8810766,14.532477 17.3918821,14.532477 C15.9032195,14.532477 14.6597875,13.483019 14.361022,12.0835389 L3,12.083704 L3,10.7828919 L14.3610257,10.7829973 C14.6598062,9.3833292 15.9032912,8.33335868 17.3918821,8.33335868 Z M17.3918821,9.63417077 C16.3988098,9.63417077 15.5935152,10.4398108 15.5935152,11.433298 C15.5935152,12.4265777 16.3986024,13.2316649 17.3918821,13.2316649 C18.3858357,13.2316649 19.1910093,12.426664 19.1910093,11.433298 C19.1910093,10.4397245 18.3856283,9.63417077 17.3918821,9.63417077 Z M6.96585666,2 C8.45497932,2 9.69864618,3.04985799 9.99746505,4.44959459 L21.9998479,4.44953325 L21.9998479,5.75034534 L9.99746871,5.7502242 C9.69866489,7.14977288 8.45505112,8.19911834 6.96585666,8.19911834 C5.47719402,8.19911834 4.23376207,7.14966037 3.9349966,5.75018022 L3,5.75034534 L3,4.44953325 L3.93500025,4.44963858 C4.23378077,3.04997053 5.47726578,2 6.96585666,2 Z M6.96585666,3.3008121 C5.97278439,3.3008121 5.16748972,4.10645217 5.16748972,5.09993929 C5.16748972,6.09321898 5.97257698,6.89830624 6.96585666,6.89830624 C7.95981027,6.89830624 8.76498386,6.09330528 8.76498386,5.09993929 C8.76498386,4.1063658 7.95960284,3.3008121 6.96585666,3.3008121 Z"
                  id="Shape"
                ></path>
              </g>
            </g>
          </svg>
        )
      }
      case "ResetFilters": {
        return (
          <svg style={{width: scale * 20}} viewBox="0 0 20 22" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="icons/reset" transform="translate(-1.000000, 0.000000)" fill="#1E1E1E" fillRule="nonzero">
                <path d="M4.36336494,7.2858386e-13 L3.82927173,5.03071105 C5.66866568,3.13696192 8.22887515,2 11.0019896,2 C16.5464911,2 21,6.49649175 21,12 C21,17.5035082 16.5464911,22 11.0019896,22 L11.0019896,22 L11.0019896,19.7777778 C15.1820277,19.7777778 18.6118157,16.3148873 18.6118157,12 C18.6118157,7.68511269 15.1820277,4.22222222 11.0019896,4.22222222 C8.43313011,4.22222222 6.08241972,5.53897379 4.68553026,7.66123195 L10.583318,8.14833544 L10.6481205,10.5203861 L1.26226313,9.8323752 L2,0.100497005 L4.36336494,7.2858386e-13 Z" id="Combined-Shape"></path>
              </g>
            </g>
          </svg>
        )
      }
      case "KnowledgeBaseSearchMagnifyer": {
        return (
          <svg style={{width: scale * 23, transform: "translate3d(0px,1px,0px)"}} viewBox="0 0 23 23" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Knowledge-Base" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="01_Desktop---KB-main-closed-message" transform="translate(-257.000000, -552.000000)">
                <g id="Group-20" transform="translate(246.000000, 541.000000)">
                  <g id="Group-15" transform="translate(-0.000000, 0.000000)">
                    <g id="Group-2-Copy"></g>
                    <path d="M14.0295671,19 C14.0295671,16.2430811 16.2776029,14 19.0406116,14 C21.8036203,14 24.0506864,16.2430811 24.0506864,19 C24.0506864,21.7569189 21.8036203,24 19.0406116,24 C16.2776029,24 14.0295671,21.7569189 14.0295671,19 L14.0295671,19 Z M33.0696938,31.8909295 L25.3410704,24.0301197 C26.3671236,22.6644916 26.9837327,20.9649108 26.9837327,19.1172378 C26.9837327,14.6416749 23.4042729,11 19.0039706,11 C14.6036682,11 11.0232313,14.6416749 11.0232313,19.1172378 C11.0232313,23.5928007 14.6036682,27.2344756 19.0039706,27.2344756 C20.5283924,27.2344756 21.9492318,26.7892053 23.1619289,26.0318482 L30.9960892,34 L33.0696938,31.8909295 Z" id="Fill-1" fill="#778080"></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        )
      }
      case "ArticlesOnlyEnglishCloseCross": {
        return (
          <svg style={{width: scale * 11}} viewBox="0 0 11 11" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Knowledge-Base" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="01_Desktop---KB-main" transform="translate(-1239.000000, -703.000000)">
                <g id="Message" transform="translate(150.000000, 662.000000)">
                  <polygon id="Fill-1" fill="#1E1E1E" points="1099.28658 41 1094.4995 45.7866447 1089.71342 41 1089 41.7133553 1093.78708 46.5 1089 51.2856357 1089.71342 52 1094.4995 47.2133553 1099.28658 52 1100 51.2856357 1095.21393 46.5 1100 41.7133553"></polygon>
                </g>
              </g>
            </g>
          </svg>
        )
      }
      case "KnowledgeBaseSearchClose": {
        return (
          <svg style={{width: scale * 15}} viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Knowledge-Base" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="05_Desktop---KB-main-search-no-results" transform="translate(-999.000000, -559.000000)" fill="#1E1E1E">
                <g id="Group-20" transform="translate(246.000000, 541.000000)">
                  <g id="Group-2-Copy" transform="translate(-0.000000, 0.000000)">
                    <polygon id="Fill-1" points="767.027153 18 760.499312 24.5272427 753.972847 18 753 18.9727573 759.527841 25.5 753 32.0258668 753.972847 33 760.499312 26.4727573 767.027153 33 768 32.0258668 761.473535 25.5 768 18.9727573"></polygon>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        )
      }
      case "OpenTicketIconCaretRight": {
        return (
          <svg style={{width: scale * 26}} viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Knowledge-Base" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="05_Desktop---KB-main-search-no-results" transform="translate(-776.000000, -1278.000000)">
                <g id="Group-12" transform="translate(0.000000, 973.000000)">
                  <g id="Group-11" transform="translate(149.000000, 0.000000)">
                    {false && <rect id="Rectangle" fill="#F8F7F8" x="0" y="0" width="1142" height="486"></rect>}
                    <path d="M640,305 C646.985656,305 652.648649,310.662993 652.648649,317.648649 C652.648649,324.634304 646.985656,330.297297 640,330.297297 C633.014344,330.297297 627.351351,324.634304 627.351351,317.648649 C627.351351,310.662993 633.014344,305 640,305 Z M638.460507,312.380835 L637.533359,313.282157 L642.018081,317.648133 L637.533489,322.013981 L638.460398,322.916347 L643.871913,317.648118 L638.460507,312.380835 Z" id="Combined-Shape" fill="#1E1E1E"></path>
                  </g>
                  <g id="Group-13" transform="translate(776.000000, 305.000000)"></g>
                </g>
              </g>
            </g>
          </svg>
        )
      }
      case "AllKbArticlesCaretLeft": {
        return (
          <svg style={{width: scale * 26}} viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Knowledge-Base" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="05_Desktop---KB-main-search-no-results" transform="translate(-150.000000, -818.000000)" fill="#1E1E1E">
                <g id="Group-4" transform="translate(150.000000, 816.000000)">
                  <path d="M13,2 C19.9856558,2 25.6486486,7.66299289 25.6486486,14.6486486 C25.6486486,21.6343044 19.9856558,27.2972973 13,27.2972973 C6.01434425,27.2972973 0.351351351,21.6343044 0.351351351,14.6486486 C0.351351351,7.66299289 6.01434425,2 13,2 Z M11.4605071,9.38083463 L10.533359,10.282157 L15.0180814,14.6481326 L10.5334892,19.0139814 L11.4603976,19.916347 L16.8719128,14.6481184 L11.4605071,9.38083463 Z" id="Combined-Shape" transform="translate(13.000000, 14.648649) rotate(-180.000000) translate(-13.000000, -14.648649) "></path>
                </g>
              </g>
            </g>
          </svg>
        )
      }
      default: {
        return <div style={{width: 20, height: 20, backgroundColor: "red"}}>?</div>
      }
    }
  }

  render = () => {
    const {debug, id, onClick, inline, ty} = this.props
    const d = {debug: debug || CIcon.defaultProps.debug}
    const style = !ty ? {} : {transform: `translate3d(0px,${ty}px,0px)`}
    if (inline) {
      return (
        <ContainerSpan {...d} iconId={id} onClick={onClick} style={style}>
          {this.renderIcon()}
        </ContainerSpan>
      )
    }
    return (
      <Container {...d} iconId={id} onClick={onClick} style={style}>
        {this.renderIcon()}
      </Container>
    )
  }
}

//  prettier-ignore
const Container = styled.div`
  position: relative;
  display: block;
  ${props => props.iconId == `TutorialPlay` && css`
    width: 24%;
  `}
  ${props => selectors.getBackgroundColorByProps(props, "rgba(255,0,0,0.5)")}
`

//  prettier-ignore
const ContainerSpan = styled.span`
  position: relative;
  display: inline-block;
  ${props => selectors.getBackgroundColorByProps(props, "rgba(0,255,0,0.5)")}
`

const svgDefaultPropTypes = {
  scale: PropTypes.number,
  pathProps: PropTypes.object,
}

const SvgVideoPlayIcon = ({scale, pathProps}) => (
  <svg style={{width: scale * 76}} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 76 76">
    <g id="Capa_1">
      <g>
        <g>
          <path
            {...pathProps}
            d="M38,75.8C17.2,75.8,0.2,58.8,0.2,38S17.2,0.2,38,0.2c20.8,0,37.8,16.9,37.8,37.8S58.8,75.8,38,75.8z M38,2.2
        C18.3,2.2,2.2,18.3,2.2,38s16,35.8,35.8,35.8s35.8-16,35.8-35.8S57.7,2.2,38,2.2z"
          />
        </g>
        <g>
          <polygon {...pathProps} points="51.7,37.5 30,25 30,50      " />
        </g>
      </g>
    </g>
  </svg>
)
SvgVideoPlayIcon.propTypes = svgDefaultPropTypes

export default CIcon
